<template>
  <messenger-popover-layout>
    <div class="text-center">
      <div class="messenger-chat-end-popover__title">{{ $t('chat.doYouWantToEndChat') }}</div>

      <div class="neutral--text lh-20 mb-6 break-word">
        <widget-translate keypath="chat.youWillReceiveChatTranscript">
          <template v-slot:email>
            <span class="font-weight-semi-bold">{{ email }}</span>
          </template>
        </widget-translate>
      </div>

      <div class="d-flex align-center flex-column">
        <widget-button
          class="full-width"
          color="danger"
          :is-loading="isEnding"
          :loading-title="$t('chat.ending')"
          @click="endChat"
        >
          {{ $t('chat.endChat') }}
        </widget-button>

        <widget-link
          text-link
          variant="primary"
          size="16"
          class="mt-5 lh-20"
          @click="onCancel"
        >
          {{ $t('common.cancel') }}
        </widget-link>
      </div>
    </div>
  </messenger-popover-layout>
</template>

<script setup lang="ts">
import MessengerPopoverLayout from '@widgets/messenger/components/popovers/MessengerPopoverLayout.vue'
import WidgetTranslate from '@widgets/shared/components/WidgetTranslate.vue'
import WidgetButton from '@widgets/shared/components/WidgetButton.vue'
import WidgetLink from '@widgets/shared/components/WidgetLink.vue'
import type { Popovers } from '@widgets/messenger/types/popover'
import { ref } from '@/composition/vue/compositionApi'

const props = defineProps<Popovers['endChat']>()

const isEnding = ref(false)

const endChat = async () => {
  isEnding.value = true
  try {
    await props.onEndChat()
  } finally {
    isEnding.value = false
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.messenger-chat-end-popover {
  &__title {
    font-size: 20px;
    line-height: 24px;
    font-weight: $bold-font;
    margin-bottom: 8px;
  }
}
</style>
